import React from 'react';
import { formatShortDateFromNow } from '../../../../../utils/date-utils/dateUtils';
import { Hyperlink } from '../../../../../components/Hyperlink';
import { buildUrlWithParameters } from '../../../../../utils/url-utils/urlUtils';
import { NotificationMessageType } from '../../../notification.types';
import { sendNotificationClickedEvent } from '../../../notificationUtils';
import { Connect } from './NotificationsMessageContainer';

type Props = {
  notification: NotificationMessageType;
  notificationClicked: Function;
  onRead: Function;
};

export class RawNotificationMessage extends React.Component<Props> {
  onNotificationClicked = async (
    event: React.MouseEvent<HTMLAnchorElement>,
  ) => {
    const { notification, notificationClicked, onRead } = this.props;
    sendNotificationClickedEvent();

    if (!notification.internalLink) {
      try {
        await onRead(notification.id);
      } catch (error) {
        throw error;
      }
    }
    notificationClicked(notification)(event);
  };

  render() {
    const { notification } = this.props;
    return (
      <Hyperlink
        className="notification-list__link"
        href={
          notification.internalLink
            ? buildUrlWithParameters(notification.link, {
                source_notification_id: notification.id,
              })
            : notification.link
        }
        onClick={this.onNotificationClicked}
        target={notification.internalLink ? '' : '_blank'}
        data-test-id="notification-message"
      >
        <span className="notification-message__border" />
        <span className="notification-list__link__content">
          <span
            className="notification-message__text"
            dangerouslySetInnerHTML={{ __html: notification.data.message }}
          />
          <span className="notification-list__link__date">
            {formatShortDateFromNow(notification.date)}
          </span>
        </span>
      </Hyperlink>
    );
  }
}
export const NotificationMessage = Connect(RawNotificationMessage);
